module.exports = __webpack_public_path__ + "img/theme3.240a728b.png";